// Folds the event stream into the list the chat view renders. Pure, and idempotent per frame id:
// when the connection drops and the server replays from Last-Event-ID, anything already applied
// is skipped, so the transcript can never duplicate.
export function reduceEvents(items, frame) {
  const { id, type, data } = frame;
  if (id != null && items.some((i) => i.seq === id)) return items;
  const seq = id;

  switch (type) {
    case 'user_message':
      // A queued message starting: its waiting bubble becomes a normal one at this point in the chat.
      return [...items.filter((i) => !(data.qid && i.kind === 'queued' && i.qid === data.qid)), { key: `u${seq}`, seq, kind: 'user', text: data.text }];
    case 'queued':
      return [...items, { key: `q${seq}`, seq, kind: 'queued', qid: data.qid, text: data.text }];
    case 'queue_cleared':
      return items.filter((i) => i.kind !== 'queued');
    case 'text':
      return [...items, { key: `t${seq}`, seq, kind: 'text', text: data.text }];
    case 'tool_use':
      return [...items, { key: `c${seq}`, seq, kind: 'tool', toolUseId: data.id, name: data.name, input: data.input, output: '', done: false, isError: false }];
    case 'tool_result': {
      const idx = items.findIndex((i) => i.kind === 'tool' && i.toolUseId === data.toolUseId);
      if (idx === -1) {
        return [...items, { key: `c${seq}`, seq, kind: 'tool', toolUseId: data.toolUseId, name: 'Tool', input: null, output: data.content, done: true, isError: !!data.isError }];
      }
      const next = items.slice();
      next[idx] = { ...next[idx], output: data.content, done: true, isError: !!data.isError, seq: next[idx].seq };
      // Remember that this result frame was applied, without moving the tool item.
      next[idx].appliedSeq = seq;
      return next;
    }
    case 'approval_request': {
      // A resolution that arrived first is kept as an invisible 'early' item; fold it in.
      const early = items.find((i) => i.kind === 'early' && i.approvalId === data.approvalId);
      const card = { key: `a${data.approvalId}`, seq, kind: 'approval', approvalId: data.approvalId, toolName: data.toolName, summary: data.summary, warning: data.warning, status: early ? early.decision : 'pending' };
      return [...items.filter((i) => i !== early), card];
    }
    case 'approval_resolved':
      if (!items.some((i) => i.kind === 'approval' && i.approvalId === data.approvalId)) {
        if (items.some((i) => i.kind === 'early' && i.approvalId === data.approvalId)) return items;
        return [...items, { key: `e${data.approvalId}`, seq, kind: 'early', approvalId: data.approvalId, decision: data.decision }];
      }
      return items.map((i) => (i.kind === 'approval' && i.approvalId === data.approvalId ? { ...i, status: data.decision, resolvedSeq: seq } : i));
    case 'done':
      return [...items, { key: `s${seq}`, seq, kind: 'status', level: 'info', text: data.stopped ? 'Stopped' : 'Done' }];
    case 'error':
      return [...items, { key: `s${seq}`, seq, kind: 'status', level: 'error', text: data.message }];
    default:
      return items;
  }
}
